module.exports = __webpack_public_path__ + "img/andre.9087601a.png";